import React, { useState, useEffect, useRef } from "react";
import { trackPromise } from "react-promise-tracker";
import services from "../../services";
import { criarPasta } from "../../services/http/pastaService";
import { Row, Col, Modal, Form, Input, message } from "antd";

import criarPastaInputSvg from "../../assets/icons/criarpastainput.svg";
import infoPastaSvg from "../../assets/icons/infoPasta.svg";
import "./styles.scss";
import { CloseOutlined } from "@mui/icons-material";
import lang from "../../assets/idioma/idiomas";

const ModalNovaPasta = ({
  pastaDestino,
  closeModal,
  openModal,
  setShowTreeData,
  setExpanddAll,
}) => {
  const { login } = services.storage.getUser();
  const [form] = Form.useForm();

  const onSubmit = (values) => {
    setShowTreeData(false);
    let data = {
      nomePasta: values.nomePasta,
      classificacao: 0,
      autor: login,
      tamanho: 0,
      tipoDocumento: 0,
      idParent: pastaDestino,
    };

    trackPromise(
      criarPasta(data)
        .then((res) => {
          if (res.fail == null) {
            setExpanddAll(false);
            setShowTreeData(true);
            message.success(lang.Pasta_criada_com_sucesso);
            closeModal(false);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  return (
    <div>
      <Modal
        title={
          <span className="modal-title-novaPasta ">{lang.Nova_pasta}</span>
        }
        visible={openModal}
        className="modal-novo"
        // onCancel={() => closeModal(false)}
        destroyOnClose={false}
        closable={false}
        footer={[]}
      >
        <CloseOutlined
          onClick={() => closeModal(false)}
          className="custom-close-icon"
        />
        <Row>
          <Col span={24}>
            <Form form={form} layout="vertical" onFinish={onSubmit}>
              <Form.Item
                name="nomePasta"
                className="label-usuario  espacoInternoNovaPasta"
              >
                <div className="criar-pasta-input">
                  <img src={infoPastaSvg} style={{ width: 40, height: 40 }} />
                  <Input
                    role={require}
                    placeholder={lang.Nome_da_pasta}
                    className="input-usuario ml-4"
                  />
                </div>
              </Form.Item>
              <div className="container-buttons">
                <button
                  type="button"
                  onClick={() => closeModal(false)}
                  className="button-modal-novo"
                >
                  {lang.Cancelar}
                </button>
                <button type="submit" className="buttonConfirmar-modal-novo">
                  {lang.Criar}
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default ModalNovaPasta;
